const privateKey = "-----BEGIN PRIVATE KEY-----\n" +
"MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCZ5pjaFO1/oo6C\n" +
"ZE08dDXA2Xg1F9NZS33TuszAfi0Dm1Kl/IeywlHJQWvnGjC9CwlqL2+H9ldIIcSb\n" +
"vBtxwZD7ss79VC/LmGgGwguBqrabQyRWDCbUpaRkziwTq5uO9GpeWywn5sl8XNsF\n" +
"AAdd6GPoy4V93fF2pHOfN0S/2Tp+L7flsk3MeXFt5R1YlyuP3VlEeGfMU0fuhADf\n" +
"fKVyS1E1dlLSIH3SI/ilOrChAyVAOmY1vyV8qq/y1L9yT/07aP3o1FwhkQ2hWnLB\n" +
"zzQBnF1gIEy5RiZHatylvAmZW+orX6PHAy/+yCfjj8GqEigt5udBE1POdfkfg40W\n" +
"yg3fxmDlAgMBAAECggEAC3ZXBTZrT5GwGv/fl8R7pMAdru32GK+3G0/4RCWcR9Pn\n" +
"loNl05dw8h7Bq63x74EqWO1XrsZBucEtbJWYlq2eanymuXaYc7RcxRS/43mvODD1\n" +
"PG+9waHk9KQSuNP+az8tdUHFmrgv4qe4y+50s1a7ADbjm5xY3v0AZofo19VqQO/C\n" +
"bWFenJAvfy1Td7009xlewyB0ioE7o0FjEaXEbIYfvHUk4BCYG322nlmoxn3ypqPV\n" +
"ZmGAHDUw3zoo3fGwuznguLphvF9L2Lr2lbf9hlt5XhfBt9oGSEKFViW8/ujxsrMy\n" +
"RTRNpdFw93Tj+8kKrAC0RUCl560dwKBIC0YjcDCaqQKBgQDUgUVV4biVLjIXRF8C\n" +
"ScnlK1mijYjlG81DWjGFW/clD5stvBD4zcBr/XgnPJNnenxQfeSr3eS1y+kk2Ygq\n" +
"bcM+TRt+Ch2WnPZWmqP2fFjFGkyyL1zFn/RDWkL9CJjGl+8ZqwJMgxW4ukBKI/WK\n" +
"xklSblaKilFEu5gO+Xi5bP1faQKBgQC5ZpzlokXitiBDl4r15gpVvo7zdBkCoX/Z\n" +
"qUfsHBY1sGORuovCJhmefinOxtIHZ2hx5pJfnyIocO4/X0yyyv4+OC0MkqgvVVPL\n" +
"oMTBDa8gWSxS7ePLKykD7dHcd8P31OZDd83q4pBBEwBlmXjnEtCM25r2ZcqoAAGA\n" +
"u+Z2Kv3CHQKBgHl1UX3ev7N0bejiiTMznZPAjUDdiIr6sv12BavlfoLOQrGHNmQe\n" +
"pYaTnyM9+jpAxeDzs8mPz/MgkycetjcZ+WgYhkgp2/ODz0B8ro5pUAuIFqIZc/r4\n" +
"i5IbewJI8ZlAqcaP+YZlvfqRacF2gBdLcgkNS6VvnTedyTF14UyKQN9RAoGBAKd8\n" +
"L1izE3cPGG53RC2HtuZm0zTTOJTL2HeFGVgOt3Gg+xH297JYQOSRDKujqLDPlebv\n" +
"aGPBmlX2TwQoz1zlTHBgxzGIey7nYl+dyKCt//q1E/mGtjYfs1m9Scxk1T/ZsHpa\n" +
"jEcYjUB8LeuajUISGRxmdsMIid7iwnjNRhCSHdNxAoGAaTCn8jikaXkS8TLFm7B6\n" +
"KgLbT8eHctLMFOLPbS6XbVdzSpYMIdw0VwoVJDqRTkbtyVumyUEW7ijeXSe7/Ezf\n" +
"PHr03TLDz0I5761jggu+nX+/zPBKNsbNBqe2da4UagcYb/Mc5x2oKDeHf2xHLOaw\n" +
"AGGScRi+Tcg+SL1mqiLkNhM=\n" +
"-----END PRIVATE KEY-----"

export default privateKey